import { Breadcrumb } from '@sentry/react';
import * as Sentry from '@sentry/react';

type Primitive = number | string | boolean | bigint | symbol | null | undefined;
interface ErrorReportingContext {
    tags?: {
        [key: string]: Primitive;
    };
}
export interface IErrorReportingService {
    setUser(
        id: string,
        email: string
    ): void;

    reportEvent(event: Breadcrumb): void;
    reportError(error: unknown, context?: ErrorReportingContext): void;
}

export default class ErrorReportingService implements IErrorReportingService {
    setUser(
        id: string,
        email: string
    ): void {
        Sentry.setUser({
            id,
            email
        });
    }

    reportEvent(event: Breadcrumb): void {
        Sentry.addBreadcrumb(event);
    }

    reportError(error: unknown, context?: ErrorReportingContext) {
        const hasContextToCapture = context?.tags;
        if (!hasContextToCapture) {
            Sentry.captureException(error);
            return;
        }

        const captureContext = {
            tags: context?.tags ?? {}
        };

        Sentry.captureException(error, captureContext);
    }
}



// WEBPACK FOOTER //
// ./src/services/error-reporting-service.ts